/* ============================================================
   saffron-lp.js — combined app.js + overlays.js for Shopify port.
   PROD build: debug panel removed; mock cart replaced with the
   real Shopify AJAX Cart API (/cart/add.js -> /checkout).
   Ported from phase5/design prototype (2026-06-17).
   ============================================================ */

/* ===================== app.js ===================== */
/* S7 prototype JS (A6): gallery tab/arrow switching + carousel arrows + video lightboxes. No libs. */
(function () {
  // block 2 gallery
  document.querySelectorAll('.b02g').forEach(function (g) {
    var slides = Array.prototype.slice.call(g.querySelectorAll('.b02g-slide'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.b02g-thumb'));
    function show(n) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === String(n)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-slide') === String(n)); });
      g.setAttribute('data-current', String(n));
    }
    function cur() { return Number(g.getAttribute('data-current') || 1); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-slide')); }); });
    var prev = g.querySelector('.b02g-prev');
    var next = g.querySelector('.b02g-next');
    if (prev) prev.addEventListener('click', function () { show((cur() + 4) % 6 + 1); });
    if (next) next.addEventListener('click', function () { show(cur() % 6 + 1); });
    // F2: tap on the visible slide → next slide (same wrap as ▶), with tap/swipe
    // discrimination so a horizontal drag/swipe isn't misread as a tap.
    slides.forEach(function (s) {
      var dx = 0, dy = 0, moved = false;
      s.addEventListener('pointerdown', function (e) { dx = e.clientX; dy = e.clientY; moved = false; });
      s.addEventListener('pointermove', function (e) {
        if (Math.abs(e.clientX - dx) > 10 || Math.abs(e.clientY - dy) > 10) moved = true;
      });
      s.addEventListener('click', function (e) {
        if (moved) return;                                             // was a swipe/drag, not a tap
        if (e.target.closest('a,button,input,label,[role="button"]')) return;  // let real controls work
        show(cur() % 6 + 1);                                           // next, wrapping — mirrors .b02g-next
      });
    });
    show(1); // default — slide 1
  });

  // scroll-snap carousel arrows (block 5, block 10)
  document.querySelectorAll('.arrow-btn[data-target]').forEach(function (b) {
    b.addEventListener('click', function () {
      var row = document.getElementById(b.getAttribute('data-target'));
      if (!row || !row.firstElementChild) return;
      var step = row.firstElementChild.getBoundingClientRect().width + 16;
      row.scrollBy({ left: b.getAttribute('data-scroll') === 'prev' ? -step : step, behavior: 'smooth' });
    });
  });

  // pointer drag-scroll for carousels (desktop affordance)
  document.querySelectorAll('.snap-row').forEach(function (row) {
    var startX = 0, startScroll = 0, dragging = false;
    row.addEventListener('pointerdown', function (e) {
      dragging = true; startX = e.clientX; startScroll = row.scrollLeft;
      row.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (dragging) row.scrollLeft = startScroll - (e.clientX - startX);
    });
    window.addEventListener('pointerup', function () {
      dragging = false; row.classList.remove('is-dragging');
    });
  });

  // video story lightboxes (self-hosted mp4): block 5 and block 9 — one pattern
  function wireLightbox(lbSel, playSel) {
    var lb = document.querySelector(lbSel);
    if (!lb) return;
    var vid = lb.querySelector('video');
    function close() { lb.hidden = true; vid.pause(); vid.removeAttribute('src'); vid.load(); }
    document.querySelectorAll(playSel + '[data-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        vid.src = btn.getAttribute('data-video');
        lb.hidden = false; vid.play();
      });
    });
    lb.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
  }
  wireLightbox('.b05-lightbox', '.b05-play, .b03-play');
  wireLightbox('.b09-lightbox', '.b09-play');

  // b07 ambient loop video — lazy: load+play only when near viewport, pause when out.
  // (perf round 2026-06-17: was autoplay+eager src → downloaded on initial load.)
  var loopVid = document.querySelector('.b07-video[data-src]');
  if (loopVid) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (!loopVid.src) { loopVid.src = loopVid.getAttribute('data-src'); }
            var p = loopVid.play(); if (p && p.catch) p.catch(function () {});
          } else {
            loopVid.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 }).observe(loopVid);
    } else {
      // no IO support — just load and play
      loopVid.src = loopVid.getAttribute('data-src');
      var p2 = loopVid.play(); if (p2 && p2.catch) p2.catch(function () {});
    }
  }
})();

/* ===================== overlays.js (prod, real Shopify cart) ===================== */
(function () {
  'use strict';

  /* ============================================================
     🔧 TIER → VARIANT CONFIG — single source of truth for cart.
     Map each pack tier (1/2/3 bottles) to its Shopify VARIANT ID.

     v1 (2026-06-17): all three TEMPORARILY point to the LIVE single
     variant 44947978813593 ($30.99) so the cart/checkout FLOW is
     testable. Checkout prices will NOT match the ladder yet — that's
     expected for v1. When Юля creates the hidden ad-clone product
     with 3 ladder variants ($39.99 / $69.99 / $95.99), swap the
     three IDs below — that's the ONLY change needed.
     ============================================================ */
  var TIER_VARIANTS = {
    1: 47917141033113, // 1 bottle  → "Saffron Drops — LP Offer (paid)" $39.99
    2: 47917141065881, // 2 bottles → $69.99 (compare-at $79.98)
    3: 47917141098649  // 3 bottles → $95.99 (compare-at $119.97)
  };

  var PRICE_SINGLE = 39.99;  // landing display price (single 4 fl oz). Ladder: 1=$39.99, 2=$69.99, 3=$95.99 (updated 2026-06-30).
  var LADDER = { 1: 39.99, 2: 69.99, 3: 95.99 };  // bottles -> landing DISPLAY price. (Checkout price comes from the variant.)
  function tierPrice(b) { return LADDER[b]; }
  function bottleLabel(b) { return b === 1 ? '1 bottle' : b + ' bottles'; }

  /* ============================================================
     🔁 SUBSCRIBE & SAVE CONFIG — re-added 2026-06-30 (Yulia).
     Wires the LP "Subscribe & Save" toggle to the EXISTING Shopify selling
     plan group "Monthly Delivery" on the LP clone product 8781498581145.
       SUB_PLAN_ID  = selling plan id (10% off, recurring monthly). Product-level
                      group → valid for ANY of the 3 pack variants.
       SUB_DISCOUNT = 0.10 — display-side discount so the LP price matches what
                      Shopify will charge (the real discount comes from the plan
                      at checkout; this is only the on-page number).
     Default state = OFF (one-time). Turning it ON shows the −10% /mo price and
     adds `selling_plan: SUB_PLAN_ID` to the cart line at checkout.
     ============================================================ */
  var SUB_PLAN_ID  = 2930606233;
  var SUB_DISCOUNT = 0.10;
  function subPrice(b) { return Math.round(LADDER[b] * (1 - SUB_DISCOUNT) * 100) / 100; }  // 1→35.99, 2→62.99, 3→86.39

  /* ============================================================
     📧 KLAVIYO EMAIL CAPTURE CONFIG — popup → welcome flow (15% off).
     All values here are PUBLIC and safe in client-side JS:
       companyId = public API key (site id), NOT a private key — never
                   put a private/secret key here.
       listId    = "WO | Saffron LP Paid | Welcome" (Sbz4tT, single opt-in) —
                   the DEDICATED paid-traffic list. Adding an email here triggers
                   our own Saffron welcome flow (Su7Pdf) that emails code SAFFRONLP15.
                   ⚠️ That flow is DRAFT until go-live — DO NOT publish this popup
                   change to the LIVE theme until the flow is set live (else captures
                   get no welcome email). Built 2026-06-24; see klaviyo-ecosystem/DESIGN.md.
       source    = 'saffron-lp-paid' (custom_source) — clean attribution of paid traffic.
     Endpoint/shape verified against Klaviyo OpenAPI (revision 2026-04-15).
     ============================================================ */
  var KLAVIYO = {
    companyId: 'SGXfyD',
    listId:    'Sbz4tT',
    revision:  '2026-04-15',
    source:    'saffron-lp-paid'
  };

  // ---- grab the relocatable nodes from the inline review block ----
  var barA   = document.querySelector('.bA-bar');
  var teaser = document.querySelector('.bB-teaser');
  var modalB = document.querySelector('.bB-modal');
  var drawer = document.querySelector('.bC-drawer');
  var hero   = document.querySelector('.b02');

  if (!barA || !teaser || !modalB || !drawer) {
    console.warn('[overlays] expected overlay nodes not found — skipping dynamic wiring');
    return;
  }

  var body = document.body;
  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }

  // ---- build fixed shells and move the nodes into them ----
  var shellA = el('div', 'ovl-a', { 'aria-hidden': 'true' });
  shellA.appendChild(barA);

  var shellTeaser = el('div', 'ovl-b-teaser');  // always visible (sticky tab), no initial is-hidden
  shellTeaser.appendChild(teaser);

  var scrimB = el('div', 'ovl-scrim', { 'aria-hidden': 'true' });
  var shellModal = el('div', 'ovl-b-modal', { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Promo offer', 'aria-hidden': 'true' });
  shellModal.appendChild(modalB);

  var scrimC = el('div', 'ovl-scrim', { 'aria-hidden': 'true' });
  var shellC = el('aside', 'ovl-c', { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Cart', 'aria-hidden': 'true' });
  shellC.appendChild(drawer);

  body.appendChild(shellA);
  body.appendChild(shellTeaser);
  body.appendChild(scrimB);
  body.appendChild(shellModal);
  body.appendChild(scrimC);
  body.appendChild(shellC);

  // ---- state ----
  var heroPast = false;     // hero scrolled above the viewport
  var modalOpen = false;
  var drawerOpen = false;
  var addedToCart = false;  // set once user adds to cart. NOTE (2026-07-01): no longer gates
                            //   the popup/teaser — a cart-adder who hasn't paid is exactly the
                            //   target. Kept because other code (dataLayer/cart) may read it.
  var subscribedB = false;  // set once email captured to Klaviyo — suppresses the popup (persists
                            //   across sessions via localStorage 'saffron_popup_email_captured')
  var checkoutIntent = false; // set synchronously at the start of goToCheckout() — user is heading
                            //   to pay, don't interrupt (also persisted in sessionStorage below)
  var teaserPulsed = false; // one-time pulse, fired after the teaser first appears
  var cart = [];            // 0 or 1 saffron line: [{ id:'saffron', bottles:N }] — price derived from LADDER
  var checkingOut = false;  // guard against double-submit during AJAX add
  var subscribeOn = false;  // Subscribe & Save toggle (default OFF — never silently enroll)
  var lastFocusModal = null;
  var lastFocusDrawer = null;

  function money(n) { return '$' + n.toFixed(2); }
  function totalQty() { return cart.reduce(function (s, i) { return s + i.bottles; }, 0); }
  function subtotal() { return cart.reduce(function (s, i) { return s + (subscribeOn ? subPrice(i.bottles) : tierPrice(i.bottles)); }, 0); }

  /* ============================================================
     📊 dataLayer events for GTM (GA4 ecommerce funnel) — PRODUCER side only.
     These push to window.dataLayer; the GA4 tags/triggers/variables are built
     in the GTM container (GTM-W86PZ8Q) by the GTM team — see
     reports/landing-saffron/analytics-tracking-plan.md (§3 разметка).
     Dedup rule: web events go to GA4 ONLY. Meta money-events (AddToCart /
     InitiateCheckout / Purchase) stay with the Shopify Meta channel — do NOT
     also forward these to Meta from GTM, or they double-count.
     Emits: view_item, select_item, add_to_cart, begin_checkout (+ scroll_depth below).
     ============================================================ */
  window.dataLayer = window.dataLayer || [];
  function dlEcom(eventName, bottles) {
    try {  // analytics must NEVER break the cart/checkout flow
      var b = LADDER[bottles] ? bottles : 1;
      window.dataLayer.push({ ecommerce: null });  // clear prior ecommerce object (GA4 best practice)
      window.dataLayer.push({
        event: eventName,
        landing_page: 'saffron-lp',   // marker → GA4 custom dimension to isolate LP funnel from the main store
        ecommerce: {
          currency: 'USD',
          value: LADDER[b],
          items: [{
            item_id: String(TIER_VARIANTS[b] || ''),
            item_name: 'Saffron Drops',
            item_variant: bottleLabel(b),
            price: LADDER[b],
            quantity: 1
          }]
        }
      });
    } catch (err) { /* swallow — never block commerce on analytics */ }
  }

  // ---------- currently selected pack -> {id,bottles,name,price} ----------
  var SINGLE = { id: 'saffron', bottles: 1, name: 'Saffron Drops · 1 bottle', price: PRICE_SINGLE };
  function packName(b) { return 'Saffron Drops · ' + bottleLabel(b); }
  function selectedPack() {
    var on = document.querySelector('.b02f-pack--on') || document.querySelector('.b02f-pack');
    if (!on) return SINGLE;
    var packs = Array.prototype.slice.call(document.querySelectorAll('.b02f-pack'));
    var idx = packs.indexOf(on);
    var bottles = idx + 1;                       // pack 0/1/2 -> 1/2/3 bottles
    if (!LADDER[bottles]) return SINGLE;
    return { id: 'saffron', bottles: bottles, name: packName(bottles), price: LADDER[bottles] };
  }

  // ---------- pack-selector price rendering (one-time ↔ subscribe) ----------
  // Snapshot each pack's original one-time price/msrp markup ONCE so we can
  // restore it exactly when the subscribe toggle goes back OFF.
  var packPriceOrig = [];
  (function snapshotPackPrices() {
    Array.prototype.slice.call(document.querySelectorAll('.b02f-pack')).forEach(function (pack) {
      var priceEl = pack.querySelector('.b02f-pack-price');
      var msrpEl = pack.querySelector('.b02f-msrp');
      packPriceOrig.push({
        price: priceEl ? priceEl.innerHTML : '',
        msrp:  msrpEl ? msrpEl.innerHTML : ''
      });
    });
  })();
  function renderPackPrices() {
    Array.prototype.slice.call(document.querySelectorAll('.b02f-pack')).forEach(function (pack, idx) {
      var bottles = idx + 1;
      var priceEl = pack.querySelector('.b02f-pack-price');
      var msrpEl = pack.querySelector('.b02f-msrp');
      var orig = packPriceOrig[idx] || { price: '', msrp: '' };
      if (subscribeOn && LADDER[bottles]) {
        // sub price + "/mo"; show the one-time price struck through as the anchor
        if (priceEl) priceEl.innerHTML = money(subPrice(bottles)) + '<span class="b02f-pack-permo">/mo</span>';
        if (msrpEl) msrpEl.innerHTML = '<s>' + money(LADDER[bottles]) + '</s>';
      } else {
        if (priceEl) priceEl.innerHTML = orig.price;
        if (msrpEl) msrpEl.innerHTML = orig.msrp;
      }
    });
  }

  // ---------- sticky-A sync ----------
  function syncBarPrice() {
    var sp = selectedPack();
    var nameEl = barA.querySelector('.bA-name');
    if (nameEl) nameEl.textContent = sp.name;
    var priceEl = barA.querySelector('.bA-price');
    if (!priceEl) return;
    var msrp = priceEl.querySelector('.bA-msrp');
    var shown = subscribeOn ? subPrice(sp.bottles) : sp.price;
    priceEl.textContent = money(shown) + (subscribeOn ? '/mo ' : ' ');
    if (msrp) priceEl.appendChild(msrp);
  }

  // ---------- pack selector wiring ----------
  var packList = Array.prototype.slice.call(document.querySelectorAll('.b02f-pack'));
  packList.forEach(function (pack) {
    pack.addEventListener('click', function () { selectPack(pack); dlEcom('select_item', selectedPack().bottles); });  /* 📊 GA4 */
    pack.addEventListener('keydown', function (e) {
      var i = packList.indexOf(pack), target = null;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPack(pack); return; }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') target = packList[(i + 1) % packList.length];
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') target = packList[(i - 1 + packList.length) % packList.length];
      else if (e.key === 'Home') target = packList[0];
      else if (e.key === 'End') target = packList[packList.length - 1];
      if (target) { e.preventDefault(); selectPack(target); target.focus(); }
    });
  });
  function selectPack(pack) {
    packList.forEach(function (p) {
      var on = p === pack;
      p.classList.toggle('b02f-pack--on', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
      p.setAttribute('tabindex', on ? '0' : '-1');
      var radio = p.querySelector('.b02f-radio');
      if (radio) radio.classList.toggle('b02f-radio--on', on);
    });
    syncBarPrice();
  }
  (function () {
    var on = document.querySelector('.b02f-pack--on');
    packList.forEach(function (p) { p.setAttribute('tabindex', p === on ? '0' : '-1'); });
  })();

  // ---------- Subscribe & Save toggle wiring ----------
  var subInput = document.getElementById('b02f-sub-input');
  var subWrap  = document.querySelector('.b02f-subscribe');
  function applySubscribeState() {
    if (subInput) subInput.setAttribute('aria-checked', subscribeOn ? 'true' : 'false');
    if (subWrap) subWrap.classList.toggle('is-on', subscribeOn);
    renderPackPrices();
    syncBarPrice();
    if (cart.length) renderCart();   // keep the open cart drawer consistent
  }
  if (subInput) {
    subInput.checked = false;        // enforce default OFF regardless of bfcache restore
    subInput.addEventListener('change', function () {
      subscribeOn = subInput.checked;
      applySubscribeState();
    });
  }

  // ============================================================
  // Overlay A — sticky ATC visibility
  // ============================================================
  // cache the sticky-bar height to avoid a forced reflow (offsetHeight read after the
  // class-toggle write) on every scroll/IntersectionObserver tick. (perf round 2026-06-17)
  var stickyAH = 0;
  function updateStickyA() {
    var show = heroPast && !drawerOpen && !modalOpen;
    shellA.classList.toggle('is-open', show);
    shellA.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show && !stickyAH) {
      // measure once, deferred to the next frame so the read is batched after layout
      requestAnimationFrame(function () {
        stickyAH = shellA.offsetHeight || 0;
        if (heroPast && !drawerOpen && !modalOpen) document.body.style.paddingBottom = stickyAH + 'px';
      });
      return;
    }
    document.body.style.paddingBottom = show ? (stickyAH + 'px') : '';
  }

  // Teaser (tab) visibility rules:
  //   - The sticky side-tab is ALWAYS shown (no heroPast gate, no once-per-session gate).
  //   - Only suppressed while the modal itself is open (restored on closeModal → updateTeaser).
  //   - addedToCart NO LONGER hides the teaser (2026-07-01): a cart-adder who hasn't paid is
  //     the target audience. Only a captured email (subscribedB) hides it — no point nagging
  //     someone who already gave us their contact.
  function teaserShouldShow() { return !subscribedB; }
  function updateTeaser() {
    if (modalOpen) return;  // tab hidden while modal is open; restored on closeModal
    var show = teaserShouldShow();
    shellTeaser.classList.toggle('is-hidden', !show);
    if (show && !teaserPulsed) {
      teaserPulsed = true;
      shellTeaser.classList.add('is-pulse');
    }
  }

  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      heroPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      updateStickyA();
      updateTeaser();
    }, { threshold: 0 }).observe(hero);
  } else {
    window.addEventListener('scroll', function () {
      if (!hero) return;
      heroPast = hero.getBoundingClientRect().bottom < 0;
      updateStickyA();
      updateTeaser();
    }, { passive: true });
  }

  // ============================================================
  // Overlay B — promo teaser -> modal (NON-FUNCTIONAL email capture;
  //             no backend wired — Klaviyo not set up yet. Visual only.)
  // ============================================================
  // F5: on mobile in-app webviews the soft keyboard shrinks the visual viewport (not the
  // layout viewport), so the fixed, centered modal can sit behind the keyboard with its
  // submit button unreachable. Pin the modal into the currently-visible area while open.
  var vv = window.visualViewport;
  function pinModalToViewport() {
    if (!vv || !modalOpen) return;
    shellModal.style.top = (vv.offsetTop + vv.height / 2) + 'px';   // keep CSS translate(-50%,-50%) centering
    shellModal.style.maxHeight = vv.height + 'px';
  }
  function unpinModalFromViewport() {
    shellModal.style.top = '';
    shellModal.style.maxHeight = '';
  }

  function openModal() {
    lastFocusModal = document.activeElement;
    modalOpen = true;
    shellModal.classList.add('is-open');
    scrimB.classList.add('is-open');
    shellModal.setAttribute('aria-hidden', 'false');
    shellTeaser.classList.add('is-hidden');
    shellTeaser.classList.remove('is-pulse');
    if (vv) {
      vv.addEventListener('resize', pinModalToViewport);
      vv.addEventListener('scroll', pinModalToViewport);
      pinModalToViewport();
    }
    updateStickyA();
    var focusIntoModal = function () {
      if (!modalOpen) return;
      if (shellModal.contains(document.activeElement)) return;
      var first = shellModal.querySelector('input, button, [href], [tabindex]:not([tabindex="-1"])');
      if (first) first.focus();
    };
    requestAnimationFrame(focusIntoModal);
    setTimeout(focusIntoModal, 280);
  }
  function closeModal() {
    modalOpen = false;
    if (vv) {
      vv.removeEventListener('resize', pinModalToViewport);
      vv.removeEventListener('scroll', pinModalToViewport);
    }
    unpinModalFromViewport();
    if (shellModal.contains(document.activeElement)) document.activeElement.blur();
    shellModal.classList.remove('is-open');
    scrimB.classList.remove('is-open');
    shellModal.setAttribute('aria-hidden', 'true');
    updateTeaser();
    updateStickyA();
    if (lastFocusModal && lastFocusModal.focus && document.contains(lastFocusModal)) lastFocusModal.focus();
    lastFocusModal = null;
  }
  teaser.addEventListener('click', openModal);
  scrimB.addEventListener('click', closeModal);
  var closeBtnB = modalB.querySelector('.bB-close');
  if (closeBtnB) closeBtnB.addEventListener('click', closeModal);

  // ============================================================
  // Auto-trigger logic for Overlay B modal (redesigned 2026-07-01).
  //
  // Context: this LP is PAID Meta traffic = a single-session visit. The whole
  // job is to capture the email WITHIN this session before the visitor bounces.
  // There is NO multi-day / time-based cooldown (Alex's final call). localStorage
  // is used ONLY for the email-captured flag, never a cooldown timestamp.
  //
  // TRIGGERS (each calls open(kind) with a soft/hard tag):
  //   T1 dwell 30s ............. SOFT
  //   T2 desktop exit-intent ... HARD (armed ~1s after load)
  //   T3 back-button trap ...... HARD (once)
  //   T4 scroll-up velocity .... HARD (only after ≥50% depth reached)
  //   T5 inactivity ≥20s ....... SOFT (only after ≥50% depth reached — combo signal)
  //
  // CADENCE — max 2 shows per session (sessionStorage counter):
  //   1st show: ANY trigger (soft or hard).
  //   2nd show: ONLY a HARD exit signal (T2/T3/T4). A soft trigger (T1/T5) must NOT
  //             produce the 2nd show.
  //   Never a 3rd show this session.
  //
  // SUPPRESSORS (never show, even if a trigger fires):
  //   subscribedB (email captured — persists across sessions via localStorage),
  //   checkoutIntent (user clicked Checkout — heading to pay), modalOpen, count ≥ 2.
  //   addedToCart is NOT a suppressor.
  // ============================================================
  var SS_KEY   = 'saffron_popup_shown';        // legacy boolean — kept written for backward-safety
  var SS_COUNT = 'saffron_popup_shown_count';  // NEW: per-session show counter (0/1/2)
  var SS_CHECKOUT = 'saffron_checkout_intent'; // NEW: checkout-intent flag (survives within tab)
  var LS_CAPTURED = 'saffron_popup_email_captured'; // NEW: cross-session email-captured flag

  function shownCount() {
    try { return parseInt(sessionStorage.getItem(SS_COUNT) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpShownCount() {
    var n = shownCount() + 1;
    try { sessionStorage.setItem(SS_COUNT, String(n)); } catch (e) { /* ignore */ }
    try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) { /* backward-safe legacy flag */ }
    return n;
  }

  // Persist email-captured across sessions: on load, hydrate subscribedB.
  try { if (localStorage.getItem(LS_CAPTURED)) subscribedB = true; } catch (e) { /* ignore */ }
  // Restore checkout-intent within this tab (survives bfcache/back to LP).
  try { if (sessionStorage.getItem(SS_CHECKOUT)) checkoutIntent = true; } catch (e) { /* ignore */ }

  var lastTrigger = null;  // for QA/debug: name+kind of the trigger that last fired open()

  // Central open function. `kind` is 'soft' or 'hard'. Applies all guards + cadence.
  function autoOpenModal(kind) {
    kind = kind === 'hard' ? 'hard' : 'soft';
    if (subscribedB) return;      // already captured — never nag
    if (checkoutIntent) return;   // heading to pay — don't interrupt
    if (modalOpen) return;
    var count = shownCount();
    if (count >= 2) return;              // never a 3rd show
    if (count >= 1 && kind !== 'hard') return;  // 2nd show requires a HARD exit signal
    bumpShownCount();
    openModal();
  }
  // Tagged wrapper so triggers read cleanly and we can record what fired.
  function fireTrigger(name, kind) {
    lastTrigger = { name: name, kind: kind };
    autoOpenModal(kind);
  }

  // --- T1 dwell 30s — SOFT ---
  setTimeout(function () { fireTrigger('T1 dwell', 'soft'); }, 30000);

  // --- T2 desktop exit-intent (mouseleave, clientY<10) — HARD ---
  // Arm ~1s after load; an instant exit-intent popup feels too aggressive.
  var exitArmed = false;
  setTimeout(function () { exitArmed = true; }, 1000);
  document.addEventListener('mouseleave', function (e) {
    if (exitArmed && e.clientY < 10) fireTrigger('T2 exit-intent', 'hard');
  });

  // --- T3 back-button trap — HARD, once ---
  // Push a dummy state on load; the first Back press pops it → show the popup and
  // re-push ONCE so that first Back shows the popup instead of leaving the page.
  // Trap only once — don't infinitely hijack navigation.
  var backTrapUsed = false;
  try { history.pushState({ sfPopup: 1 }, ''); } catch (e) { /* ignore */ }
  window.addEventListener('popstate', function () {
    if (backTrapUsed) return;               // only trap the first Back press
    backTrapUsed = true;
    if (subscribedB || checkoutIntent || shownCount() >= 2) return;  // let them leave
    try { history.pushState({ sfPopup: 1 }, ''); } catch (e) { /* ignore */ }  // re-arm once so we stay
    fireTrigger('T3 back-button', 'hard');
  });

  // --- scroll-depth gate (shared by T4 + T5): mark once ≥50% page depth reached ---
  var passedHalf = false;
  function docScrollable() {
    return Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - window.innerHeight;
  }
  function scrollDepthFrac() {
    var max = docScrollable();
    if (max <= 0) return 0;
    return (window.pageYOffset || document.documentElement.scrollTop || 0) / max;
  }

  // --- T4 scroll-up velocity — HARD (only after ≥50% depth) ---
  var lastY = window.pageYOffset || 0;
  var lastT = Date.now();
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var now = Date.now();
    if (!passedHalf && scrollDepthFrac() >= 0.5) passedHalf = true;
    var dy = y - lastY;            // negative = scrolling up
    var dt = now - lastT || 1;
    var vel = dy / dt;             // px/ms; large-negative = fast upward
    if (passedHalf && vel < -1.2) fireTrigger('T4 scroll-up', 'hard');
    lastY = y; lastT = now;
    resetIdle();  // any scroll counts as activity for T5
  }, { passive: true });

  // --- T5 inactivity ≥20s AFTER ≥50% depth — SOFT (combo signal, not a bare timer) ---
  var idleTimer = null;
  var IDLE_MS = 20000;
  function resetIdle() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      if (passedHalf) fireTrigger('T5 inactivity', 'soft');
    }, IDLE_MS);
  }
  ['mousemove', 'keydown', 'touchstart', 'pointerdown'].forEach(function (evt) {
    document.addEventListener(evt, resetIdle, { passive: true });
  });
  resetIdle();  // start the idle clock

  // ============================================================
  // ---- email capture → Klaviyo client subscribe → list Sbz4tT (paid) → welcome flow Su7Pdf emails the 15% code ----
  var formB  = modalB.querySelector('.bB-form');
  var emailB = modalB.querySelector('#bB-email');
  var btnB   = modalB.querySelector('.bB-btn');
  var msgB   = modalB.querySelector('.bB-msg');
  var submittingB = false;

  function setMsgB(text, kind) {
    if (!msgB) return;
    msgB.textContent = text || '';
    msgB.className = 'bB-msg' + (kind ? ' bB-msg--' + kind : '');
    msgB.hidden = !text;
  }
  function validEmailB(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function subscribeKlaviyoB(email) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: KLAVIYO.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(KLAVIYO.companyId), {
      method: 'POST',
      headers: { 'revision': KLAVIYO.revision, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function handleSubscribeB(e) {
    if (e) e.preventDefault();
    if (submittingB) return;
    if (subscribedB) { closeModal(); return; }   // already done — button now just closes
    var email = ((emailB && emailB.value) || '').trim();
    if (!validEmailB(email)) {
      setMsgB('Please enter a valid email.', 'error');
      if (emailB) emailB.focus();
      return;
    }
    submittingB = true;
    if (btnB) { btnB.disabled = true; btnB.dataset.label = btnB.textContent; btnB.textContent = 'Sending…'; }
    setMsgB('', null);
    subscribeKlaviyoB(email)
      .then(function (res) {
        if (res.status !== 202) throw new Error('HTTP ' + res.status);
        subscribedB = true;
        // Persist across sessions so a returning subscriber is never nagged again.
        try { localStorage.setItem(LS_CAPTURED, '1'); } catch (e) { /* private-mode may throw */ }
        setMsgB('✓ Check your inbox — your 15% code is on the way.', 'ok');
        if (emailB) emailB.disabled = true;
        if (btnB) { btnB.disabled = false; btnB.textContent = 'Done'; }
        setTimeout(function () { if (subscribedB) closeModal(); }, 2600);
      })
      .catch(function () {
        setMsgB('Something went wrong — please try again.', 'error');
        if (btnB) { btnB.disabled = false; btnB.textContent = (btnB.dataset.label || 'Get my 15%'); }
      })
      .then(function () { submittingB = false; });
  }

  if (formB) formB.addEventListener('submit', handleSubscribeB);
  else if (btnB) btnB.addEventListener('click', handleSubscribeB);  // fallback if markup isn't wrapped in <form>

  // ============================================================
  // Overlay C — cart drawer (REAL Shopify cart on checkout)
  // ============================================================
  function openDrawer() {
    lastFocusDrawer = document.activeElement;
    drawerOpen = true;
    shellC.classList.add('is-open');
    scrimC.classList.add('is-open');
    shellC.setAttribute('aria-hidden', 'false');
    updateStickyA();
    var f = shellC.querySelector('.bC-close');
    if (f) f.focus();
  }
  function closeDrawer() {
    drawerOpen = false;
    if (shellC.contains(document.activeElement)) document.activeElement.blur();
    shellC.classList.remove('is-open');
    scrimC.classList.remove('is-open');
    shellC.setAttribute('aria-hidden', 'true');
    updateStickyA();
    if (lastFocusDrawer && lastFocusDrawer.focus && document.contains(lastFocusDrawer)) lastFocusDrawer.focus();
    lastFocusDrawer = null;
  }
  scrimC.addEventListener('click', closeDrawer);
  var closeBtnC = drawer.querySelector('.bC-close');
  if (closeBtnC) closeBtnC.addEventListener('click', closeDrawer);

  var TIERS = [
    { bottles: 1, price: 39.99, msrp: null,    badge: null },
    { bottles: 2, price: 69.99, msrp: 79.98,   badge: '🚚 Free shipping' },
    { bottles: 3, price: 95.99, msrp: 119.97,  badge: '⭐ Most popular' }
  ];
  function activeBottles() { return cart.length ? cart[0].bottles : 0; }

  function selectTier(bottles) {
    if (!LADDER[bottles]) return;
    if (cart.length) cart[0].bottles = bottles;
    else cart.push({ id: 'saffron', bottles: bottles });
    renderCart();
  }
  function removeFromCart() { cart = []; renderCart(); }

  function addToCart() {
    selectTier(selectedPack().bottles);
    dlEcom('add_to_cart', selectedPack().bottles);   // 📊 GA4 funnel
    addedToCart = true;
    if (modalOpen) closeModal();
    // NOTE (2026-07-01): do NOT hide the teaser and do NOT stop the popup timers on
    // add-to-cart. A cart-adder who hasn't paid is exactly the target — the popup must
    // still be able to fire. addedToCart no longer gates the popup/teaser.
    preClearCart();  // pre-warm: clear the Shopify cart in the background on buy intent (see below)
  }

  // The LP never writes to the Shopify cart except in goToCheckout(), so clearing it
  // early — as soon as the user shows buy intent (Add to Cart) — is safe and moves the
  // ~0.7s clear round-trip OFF the checkout click. clear ALWAYS precedes add, so the
  // final cart is exactly the selected tier (no duplicate-tier on back-button/retry).
  var clearPromise = null;
  function preClearCart() {
    if (clearPromise) return clearPromise;
    clearPromise = fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .catch(function () { clearPromise = null; });  // failed → allow retry / fall back at checkout
    return clearPromise;
  }

  // ---- REAL Shopify checkout: ensure cart cleared, add the selected tier variant, go to /checkout ----
  function goToCheckout() {
    // Checkout intent = proxy conversion. Set the popup suppressor SYNCHRONOUSLY, before
    // any early-return or async work, so the popup can never fire while the user is heading
    // to pay. sessionStorage persists it across the checkoutFallback() edge (brief stay on LP).
    checkoutIntent = true;
    try { sessionStorage.setItem(SS_CHECKOUT, '1'); } catch (e) { /* private-mode may throw */ }
    var b = activeBottles();
    if (!b || checkingOut) return;
    dlEcom('begin_checkout', b);   // 📊 GA4 funnel (fires once per real checkout initiation)
    var variantId = TIER_VARIANTS[b];
    if (!variantId) { console.error('[cart] no variant mapped for tier', b); return; }
    checkingOut = true;
    var noteEl = drawer.querySelector('.ovl-cart-note');
    if (noteEl) noteEl.textContent = 'Taking you to secure checkout…';
    var btn = drawer.querySelector('.ovl-cart-checkout');
    if (btn) { btn.disabled = true; btn.textContent = 'Loading…'; }

    // Wait for the (usually already-finished) background clear, then add exactly the
    // selected tier (qty 1) and redirect. Transient failures — most notably Shopify's
    // "Verifying your connection" 429 bot-challenge on the Ajax cart API, or a network
    // blip — are retried, then recovered via a full-page cart permalink so a hiccup
    // never dead-ends a paid click. (Root cause of the old "Sorry, something went
    // wrong" report: ANY non-OK /cart/add.js surfaced that message with no retry.)
    var delay = function (ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); };

    // Last resort when the Ajax add keeps failing: navigate to the native cart
    // permalink. A top-level GET carries the variant (+ selling plan) and can pass a
    // bot challenge that an XHR cannot solve — the shopper still reaches the cart.
    function checkoutFallback() {
      var url = '/cart/' + variantId + ':1' + (subscribeOn ? '?selling_plan=' + SUB_PLAN_ID : '');
      if (noteEl) noteEl.textContent = 'One moment — taking you to your cart…';
      window.location.href = url;
    }

    function attemptAdd(triesLeft) {
      // Shopify Cart AJAX API: `selling_plan` is a top-level prop on the line item →
      // recurring 10%-off monthly. Omit entirely for one-time. Ref: shopify.dev/docs/api/ajax/reference/cart.
      var line = { id: variantId, quantity: 1 };
      if (subscribeOn) line.selling_plan = SUB_PLAN_ID;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (res) {
        if (res.ok) { window.location.href = '/checkout'; return; }
        if (triesLeft > 0) {
          // re-clear first so the retry keeps the clear-before-add invariant (no dup line)
          return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .catch(function () {})
            .then(function () { return delay(500); })
            .then(function () { return attemptAdd(triesLeft - 1); });
        }
        console.error('[cart] add.js failed after retries, status:', res.status);
        checkoutFallback();
      }).catch(function (err) {
        if (triesLeft > 0) { return delay(500).then(function () { return attemptAdd(triesLeft - 1); }); }
        console.error('[cart] checkout error:', err);
        checkoutFallback();
      });
    }

    Promise.resolve(preClearCart()).then(function () { return attemptAdd(2); });
  }

  function renderCart() {
    var b = activeBottles();
    var titleEl = drawer.querySelector('.bC-title');
    var shipEl = drawer.querySelector('.bC-ship-text');
    var fillEl = drawer.querySelector('.bC-fill');
    var emptyEl = drawer.querySelector('.bC-empty');

    if (titleEl) titleEl.textContent = 'Cart • ' + b;

    var FREE_SHIP_QTY = 2;
    if (shipEl) {
      if (b >= FREE_SHIP_QTY) shipEl.textContent = "You've unlocked free shipping 🎉";
      else if (b === FREE_SHIP_QTY - 1) shipEl.textContent = 'Add 1 more bottle for free shipping';
      else shipEl.textContent = 'Free shipping on 2+ bottles';
    }
    if (fillEl) fillEl.style.width = Math.min(b / FREE_SHIP_QTY, 1) * 100 + '%';

    if (emptyEl) emptyEl.style.display = 'none';

    var picker = drawer.querySelector('.ovl-cart-picker');
    if (!picker) {
      picker = el('div', 'ovl-cart-picker', { role: 'radiogroup', 'aria-label': 'Choose your pack' });
      var shipBlock = drawer.querySelector('.bC-ship');
      if (shipBlock && shipBlock.nextSibling) drawer.insertBefore(picker, shipBlock.nextSibling);
      else drawer.appendChild(picker);
    }
    picker.innerHTML =
      '<p class="ovl-cart-pick-label" aria-hidden="true">Choose your pack</p>' +
      TIERS.map(function (t) {
        var on = t.bottles === b;
        return '<button type="button" role="radio" class="ovl-cart-tier' + (on ? ' is-on' : '') + '" data-tier="' + t.bottles + '" aria-checked="' + on + '">' +
                 '<span class="ovl-tier-radio" aria-hidden="true"></span>' +
                 '<span class="ovl-tier-main">' +
                   '<span class="ovl-tier-name">' + bottleLabel(t.bottles) + (t.bottles === 1 ? ' (4 fl oz)' : '') + '</span>' +
                   (t.badge ? '<span class="ovl-tier-badge">' + t.badge + '</span>' : '') +
                 '</span>' +
                 '<span class="ovl-tier-price">' +
                   (subscribeOn
                     ? money(subPrice(t.bottles)) + '<span class="ovl-tier-permo">/mo</span> <s>' + money(t.price) + '</s>'
                     : money(t.price) + (t.msrp ? ' <s>' + money(t.msrp) + '</s>' : '')) +
                 '</span>' +
               '</button>';
      }).join('');
    picker.querySelectorAll('.ovl-cart-tier').forEach(function (btn) {
      btn.addEventListener('click', function () { var t = parseInt(btn.getAttribute('data-tier'), 10); selectTier(t); dlEcom('select_item', t); });  /* 📊 GA4 */
    });

    // ---------- cart subscribe toggle (created once, synced on every renderCart) ----------
    var cartSubBlock = drawer.querySelector('.ovl-cart-subscribe');
    if (!cartSubBlock) {
      cartSubBlock = el('div', 'ovl-cart-subscribe');
      cartSubBlock.innerHTML =
        '<label class="ovl-cart-sub-switch" aria-label="Subscribe &amp; Save 10%">' +
          '<input type="checkbox" class="ovl-cart-sub-input" role="switch" aria-checked="false">' +
          '<span class="b02f-sub-track" aria-hidden="true"><span class="b02f-sub-knob"></span></span>' +
        '</label>' +
        '<span class="b02f-sub-text">' +
          '<span class="b02f-sub-head">Subscribe &amp; Save' +
            '<span class="badge badge--green b02f-sub-badge">10% OFF</span>' +
          '</span>' +
          '<span class="b02f-sub-copy">Delivered monthly, cancel anytime.</span>' +
        '</span>';
      // Insert between picker and footer (or append if no picker yet)
      var afterPicker = drawer.querySelector('.ovl-cart-picker');
      if (afterPicker && afterPicker.nextSibling) drawer.insertBefore(cartSubBlock, afterPicker.nextSibling);
      else drawer.appendChild(cartSubBlock);

      // clicking the cart toggle → mutate shared flag → sync everything (main toggle + cart prices)
      var cartSubInput = cartSubBlock.querySelector('.ovl-cart-sub-input');
      cartSubInput.addEventListener('change', function () {
        subscribeOn = cartSubInput.checked;
        // keep the main hero toggle in sync
        if (subInput) subInput.checked = subscribeOn;
        applySubscribeState();  // updates main toggle class, renderPackPrices, syncBarPrice, renderCart
      });
    }
    // sync cart toggle visual to current subscribeOn state on every render
    var cartSubInput = cartSubBlock.querySelector('.ovl-cart-sub-input');
    if (cartSubInput) {
      cartSubInput.checked = subscribeOn;
      cartSubInput.setAttribute('aria-checked', subscribeOn ? 'true' : 'false');
    }
    cartSubBlock.classList.toggle('is-on', subscribeOn);

    var footer = drawer.querySelector('.ovl-cart-footer');
    if (!footer) {
      footer = el('div', 'ovl-cart-footer');
      footer.innerHTML =
        '<div class="ovl-cart-subtotal"><span>Subtotal</span><span class="ovl-cart-sub-val"></span></div>' +
        '<button class="btn ovl-cart-checkout" type="button">Checkout</button>' +
        '<button type="button" class="ovl-cart-remove">Remove from cart</button>' +
        '<p class="ovl-cart-note">Secure checkout · 30-DAY SATISFACTION GUARANTEE</p>';
      drawer.appendChild(footer);
      footer.querySelector('.ovl-cart-checkout').addEventListener('click', goToCheckout);
      footer.querySelector('.ovl-cart-remove').addEventListener('click', removeFromCart);
    }
    footer.querySelector('.ovl-cart-sub-val').textContent = money(b ? subtotal() : 0) + (b && subscribeOn ? '/mo' : '');
    footer.querySelector('.ovl-cart-checkout').disabled = !b;
    footer.querySelector('.ovl-cart-remove').style.display = b ? '' : 'none';
  }

  // add-to-cart triggers: main CTA + sticky-A button
  var ctaMain = document.querySelector('.b02f-cta');
  var ctaBarA = barA.querySelector('.bA-btn');
  if (ctaMain) ctaMain.addEventListener('click', function () { addToCart(); openDrawer(); });
  if (ctaBarA) ctaBarA.addEventListener('click', function () { addToCart(); openDrawer(); });
  var cartIcon = document.querySelector('.b01-iconbtn[aria-label="Cart"]');
  if (cartIcon) cartIcon.addEventListener('click', openDrawer);

  // Esc closes the topmost open overlay
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawerOpen) closeDrawer();
    else if (modalOpen) closeModal();
  });

  // bfcache restore: clicking Checkout sets checkingOut=true, swaps the button to
  // "Loading…"/disabled and the note to "Taking you…", then redirects to /checkout.
  // If the user hits Back, the page comes back from bfcache and JS does NOT re-run —
  // so checkingOut stays true (goToCheckout early-returns forever → checkout dead) and
  // the button/note stay in their loading state. Even worse, switching a tier calls
  // renderCart() which re-enables the button but leaves the "Loading…" label and never
  // resets checkingOut — it looks clickable but does nothing. On a persisted pageshow
  // we fully reset the checkout state so the user can check out again.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    checkingOut = false;
    clearPromise = null;  // re-clear the cart on the next checkout (memoized pre-clear was reset)
    var btn = drawer.querySelector('.ovl-cart-checkout');
    if (btn) { btn.textContent = 'Checkout'; btn.disabled = !activeBottles(); }
    var noteEl = drawer.querySelector('.ovl-cart-note');
    if (noteEl) noteEl.textContent = 'Secure checkout · 30-DAY SATISFACTION GUARANTEE';
    // The browser may persist the checkbox's checked state across bfcache restore.
    // Re-sync our flag to the ACTUAL checkbox so the price display and the
    // selling_plan line stay truthful (never a hidden mismatch).
    if (subInput) { subscribeOn = !!subInput.checked; applySubscribeState(); }
  });

  // ---- init ----
  renderPackPrices();   // default OFF — restores the static one-time prices from markup
  syncBarPrice();
  renderCart();
  dlEcom('view_item', selectedPack().bottles);   // 📊 GA4 funnel — LP product shown
  console.log('[overlays] saffron-lp overlays ready (real Shopify cart).');
})();

/* ===================== header.js — burger menu + nav links + search ===================== */
(function () {
  'use strict';

  // ---------- Search → store search ----------
  var searchBtn = document.getElementById('b01-search');
  if (searchBtn) searchBtn.addEventListener('click', function () { window.location.href = '/search'; });

  // ---------- Smooth scroll for on-page nav anchors ----------
  function smoothScrollTo(hash) {
    if (!hash || hash.charAt(0) !== '#') return false;
    var target = document.getElementById(hash.slice(1));
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }
  Array.prototype.slice.call(document.querySelectorAll('.b01-navlink')).forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (smoothScrollTo(a.getAttribute('href'))) e.preventDefault();
    });
  });

  // ---------- Mobile slide-in menu (same overlay pattern as the cart drawer) ----------
  var burger = document.getElementById('b01-burger');
  var menu   = document.getElementById('b01-menu');
  if (!burger || !menu) {
    console.warn('[header] burger/menu nodes not found — skipping menu wiring');
    return;
  }

  var body = document.body;
  var scrim = document.createElement('div');
  scrim.className = 'ovl-scrim';
  scrim.setAttribute('aria-hidden', 'true');

  var shell = document.createElement('nav');
  shell.className = 'ovl-menu';
  shell.setAttribute('role', 'dialog');
  shell.setAttribute('aria-modal', 'true');
  shell.setAttribute('aria-label', 'Menu');
  shell.setAttribute('aria-hidden', 'true');
  shell.appendChild(menu);          // relocate the inline <nav> into the fixed shell

  body.appendChild(scrim);
  body.appendChild(shell);

  var menuOpen = false;
  var lastFocus = null;

  function openMenu() {
    lastFocus = document.activeElement;
    menuOpen = true;
    shell.classList.add('is-open');
    scrim.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    var first = shell.querySelector('.b01-menu-close');
    if (first) first.focus();
  }
  function closeMenu() {
    menuOpen = false;
    if (shell.contains(document.activeElement)) document.activeElement.blur();
    shell.classList.remove('is-open');
    scrim.classList.remove('is-open');
    shell.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  burger.addEventListener('click', function () { menuOpen ? closeMenu() : openMenu(); });
  scrim.addEventListener('click', closeMenu);
  var closeBtn = shell.querySelector('.b01-menu-close');
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  // menu links: smooth-scroll + close
  Array.prototype.slice.call(shell.querySelectorAll('.b01-menu-link')).forEach(function (a) {
    a.addEventListener('click', function (e) {
      var hash = a.getAttribute('href');
      var target = (hash && hash.charAt(0) === '#') ? document.getElementById(hash.slice(1)) : null;
      if (target) {
        e.preventDefault();
        closeMenu();
        // wait for the close transition so scroll lands accurately
        setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
      }
    });
  });

  // Esc closes the menu (only when no other overlay handles it — menu is its own context)
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuOpen) closeMenu();
  });

  // simple focus trap inside the open menu
  shell.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !menuOpen) return;
    var focusable = shell.querySelectorAll('a[href], button:not([disabled])');
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  console.log('[header] saffron-lp header ready (burger menu + nav links + search).');
})();

/* ===================== hero micro-nav (F3/F4): rating → reviews, badges → offer / certs ===================== */
(function () {
  'use strict';
  function scrollToEl(elm) { if (elm) elm.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  function wireScroll(node, targetGetter) {
    if (!node) return;
    node.setAttribute('role', 'button');
    node.setAttribute('tabindex', '0');
    node.style.cursor = 'pointer';
    var go = function (e) {
      if (e) e.stopPropagation();          // don't also trigger the gallery tap-advance (F2)
      scrollToEl(targetGetter());
    };
    node.addEventListener('click', go);
    node.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(e); }
    });
  }
  var reviews = function () { return document.getElementById('reviews'); };
  var offer   = function () { return document.querySelector('.b02f-packs') || document.getElementById('offer'); };
  var certs   = function () { return document.querySelector('.b04-badges') || document.querySelector('.b04'); };

  // F3 — rating (stars + "4.6 stars (910 reviews)") → reviews block (#reviews / b10)
  wireScroll(document.querySelector('.b02f-rating .stars'), reviews);
  wireScroll(document.querySelector('.b02f-rating-text'), reviews);

  // F4 — hero badges
  wireScroll(document.querySelector('.b02f-rating .badge--purple'), offer);              // BEST SELLER → offer/tiers
  wireScroll(document.querySelector('.b02g-slide[data-slide="1"] .offer'), offer);       // Save up to 20% → offer/tiers
  wireScroll(document.querySelector('.b02g-slide[data-slide="1"] .badge--round'), certs); // Made in USA → cert badges (.b04-badges)
})();

/* ---- 2f Launch-batch scarcity bar — симуляция низкого остатка (решение W&O 2026-06-18).
   Всегда «почти распродано»: claimed ~85–94%, осталось ~10–24 шт.
   Стабильно в течение часа (без сброса на рефреше), медленно убывает в течение дня. ---- */
(function () {
  var fill = document.querySelector('.b02f-stock-fill');
  var unitsEl = document.querySelector('.b02f-stock-units');
  if (!fill) return;
  var now = new Date();
  var h = now.getHours();                                       // стабильно в пределах часа
  var dayJitter = (now.getDate() * 7 + now.getMonth() * 3) % 4; // 0..3, стабильно за день
  var remaining = 14 - (h / 24) * 7 - dayJitter * 0.8;          // ~14% → ~7% за день
  if (remaining < 6) remaining = 6;
  if (remaining > 15) remaining = 15;
  var claimed = Math.round(100 - remaining);                    // ~85..94%
  fill.style.width = claimed + '%';
  if (unitsEl) {
    var units = Math.max(5, Math.round(remaining * 1.7));       // ~10..24 шт.
    unitsEl.textContent = units;
  }
})();

/* ============================================================
   📊 scroll-depth by block → dataLayer (GA4). Answers "where do users drop off".
   Fires `scroll_depth` ONCE per content block (b00..b11) when it first crosses
   ~50% into view. GA4 tag/trigger built in GTM (GTM-W86PZ8Q) — see
   reports/landing-saffron/analytics-tracking-plan.md.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;
  window.dataLayer = window.dataLayer || [];
  var fired = {};
  var blocks = Array.prototype.slice.call(document.querySelectorAll('section.blk'));
  if (!blocks.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var m = (e.target.className || '').toString().match(/\bb(\d{2})\b/);
      var id = m ? 'b' + m[1] : null;
      if (!id || fired[id]) return;
      fired[id] = true;
      window.dataLayer.push({
        event: 'scroll_depth',
        landing_page: 'saffron-lp',
        block_id: id,
        block_index: parseInt(m[1], 10)
      });
      io.unobserve(e.target);  // once per block
    });
  }, { threshold: 0.5 });
  blocks.forEach(function (b) { io.observe(b); });
})();
